import { authFetch } from "lib/api/authFetch";
import { BACKEND_URL } from "lib/utils/baseUrl";
import { hasValue } from "lib/utils/hasValue";

export async function getProjectElectricalSafetyReportData(
  projectId,
  { sortKey, sortDir, listScope } = {},
) {
  if (!hasValue(projectId)) {
    return {
      success: false,
      message: "유효하지 않은 프로젝트 ID입니다.",
      files: [],
      totalCount: 0,
    };
  }

  try {
    const qs = new URLSearchParams();
    if (listScope) qs.set("listScope", JSON.stringify(listScope));
    if (hasValue(sortKey)) qs.set("sortKey", String(sortKey));
    if (hasValue(sortDir)) qs.set("sortDir", String(sortDir));

    const path = `${BACKEND_URL}/project/report_preview/electrical_safety/${projectId}?${qs.toString()}`;
    const res = await authFetch(
      path,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      },
      {
        refreshUrlIncludes: "auth/refresh",
      },
    );

    if (res.status === 401) {
      return {
        success: false,
        message: "인증이 만료되었습니다. 다시 로그인해 주세요.",
        files: [],
        totalCount: 0,
      };
    }

    const result = await res.json().catch(() => null);
    if (!result) {
      return {
        success: false,
        message: "서버 응답 파싱에 실패했습니다.",
        files: [],
        totalCount: 0,
      };
    }

    if (!res.ok || !result?.success) {
      return {
        success: false,
        message:
          result?.message || "프로젝트 전기 직무고시 보고서 데이터를 불러오지 못했습니다.",
        files: [],
        totalCount: 0,
      };
    }

    return {
      success: true,
      message: result?.message,
      files: Array.isArray(result?.data?.files) ? result.data.files : [],
      totalCount: Number(result?.data?.totalCount) || 0,
      sort: result?.data?.sort || {
        sortKey: sortKey || "uploaded_at",
        sortDir: sortDir || "DESC",
      },
    };
  } catch (error) {
    console.error("[getProjectElectricalSafetyReportData] request failed:", error);
    return {
      success: false,
      message: "서버 요청 중 오류가 발생했습니다.",
      files: [],
      totalCount: 0,
    };
  }
}
